import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import AccordionSection from '../AccordionSection'

import ProcessingGDPRSuppressionImage from './ProcessingGDPRSuppressionImage'

const data = {
  anchorId: `gdpr-suppression-and-deletion`,
  overline: `Processing`,
  heading: `GDPR Suppression and Deletion`,
  description: `If you’re working with data today, you must be compliant with the GDPR and CCPA. Both grant individual users the ability to request that their data be deleted or suppressed. It’s sort of like finding 100k needles in 100 billion haystacks—but here’s how we do it.`,
  buttonTextLink: `/product/gdpr/`,
  buttonTextLinkText: `Learn more`,
  accordionSection: SectionWithAccordion.GDPR_SUPPRESSION,
}

const ProcessingGDPRSuppression: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()
  const { anchorId, overline, heading, description, buttonTextLink, buttonTextLinkText, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <Spacer>{description}</Spacer>
            </CopyText.Description>
            <Spacer>
              <ButtonText tag="a" href={getAbsoluteUrl(buttonTextLink, pageConfig)} iconEnd={ChevronRightIcon}>
                {buttonTextLinkText}
              </ButtonText>
            </Spacer>
            <AccordionSection section={accordionSection} />
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <ProcessingGDPRSuppressionImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const Spacer = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default ProcessingGDPRSuppression
